/* ============
 * Campaign Module State
 * ============
 */

export default {
  all: [],
  items: [],
  pagination: {
    currentPage: 1,
    lastPage: 0,
    limit: 5,
    totalCount: 0,
  },
  types: [],
};



// WEBPACK FOOTER //
// ./src/app/store/modules/campaign/state.js